class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  connectedCallback() {
    this.content = this.querySelector("[data-content]");
    this.open = this.querySelector("[data-open]");
    this.close = this.querySelector("[data-close]");
    this.openColor = this.getAttribute("open-color");
    this.closedColor = this.getAttribute("closed-color");

    this.addEventListener("click", () => {
      this.toggle();
    });

    this.update();
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.update();
  }

  update() {
    if (this.isOpen) {
      this.content.classList.remove("max-h-0", "opacity-0");
      this.content.classList.add("max-h-auto", "opacity-100");
      this.open.classList.add("hidden");
      this.close.classList.remove("hidden");
      this.style.borderTopColor = this.openColor;
    } else {
      this.content.classList.remove("max-h-96", "opacity-100");
      this.content.classList.add("max-h-0", "opacity-0");
      this.open.classList.remove("hidden");
      this.close.classList.add("hidden");
      this.style.borderTopColor = this.closedColor;
    }
  }
}

customElements.define("accordion-item", AccordionItem);
